import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import WalletButton from "components/WalletProvider/WalletButton";
import st_nav from "./Nav.module.css";

const WebNav = () => {
    const location = useLocation();
    const home = location.pathname === "/";
    
    return (
        <div className={home ? st_nav.home_links : st_nav.charity_links}>
        { home && <>
        <ScrollLink 
        to="donate_now" 
        duration={500}
        spy={true} 
        smooth={true}>
            Donate Now
        </ScrollLink>
        <ScrollLink 
        to="all_charities" 
        duration={500}
        spy={true} 
        smooth={true}>
            Humanitarian Relief Partners
        </ScrollLink>
        {/* <a>Anchor Perpetual</a> */}
        </>}
        { !home && <>
            <Link to="/">Home</Link>
        </>}
        <WalletButton/>
    </div>
    )
}

export default WebNav;